import * as React from 'react';

import { Checkbox, Toolbar, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
  CustomTableCellCheckBox,
  CustomTableCellDownload,
  CustomTableCellReportStatus,
  CustomTableCellRimStatus,
  CustomTableCellText,
  CustomTableSentDateAndRefresh,
} from './material-ui-styles';

import { CommunicationOverviewReportItemForDisplay } from '../../../../store/details/overview/types';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { Paper, Table, TableBody, TableRow } from '@mui/material';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './overview.module.css';
import { BelfiusTooltip } from 'src/components/custom/belfius-tooltip';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import Tooltip from '@mui/material/Tooltip';
import TableCell from '@mui/material/TableCell';

interface Props {
  readonly title: string;
  readonly rows: CommunicationOverviewReportItemForDisplay[];
  readonly toggleItem: (id: number) => void;
  readonly togleAll?: (checked: boolean) => void;
  readonly toggleAllChecked: boolean;
  readonly currentLanguage: string;
  readonly handleDownloadClick: (amazonKey: string, filename: string) => void; // Handle independently
  readonly caseBlocked: boolean;
}

type AllProps = Props;

export class OverviewTableReport extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <Paper>
        <Toolbar className={styles.toolbar}>
          <Typography variant="h5" id="tableTitle">
            {this.props.title}
          </Typography>
        </Toolbar>

        <Table className={styles.table}>
          <TableBody>
            {this.props.rows.map((row) => (
              <TableRow hover key={row.id()}>
                {row.virusDetected() ? (
                  <TableCell>
                    <Tooltip title="Virus detected">
                      <div>
                        <CoronavirusIcon color="error" />
                      </div>
                    </Tooltip>
                  </TableCell>
                ) : (
                  <CustomTableCellCheckBox padding="checkbox">
                    <Checkbox
                      disabled={!row.canDelete() || this.props.caseBlocked || row.queuedForSending()}
                      checked={row.selected()}
                      onChange={() => this.props.toggleItem(row.id())}
                    />
                  </CustomTableCellCheckBox>
                )}

                <CustomTableCellText component="th" scope="row">
                  {row.subjectLine()}
                </CustomTableCellText>

                <CustomTableCellReportStatus>{row.reportType()}</CustomTableCellReportStatus>

                <CustomTableCellRimStatus>
                  {/* RIM STATUS */}
                </CustomTableCellRimStatus>

                {row.virusDetected() || row.isScanning() ? (
                  <CustomTableCellText component="th" scope="row">
                  </CustomTableCellText>
                ) : (
                  <CustomTableCellDownload component="th" scope="row">
                    <div
                      className={styles.link}
                      onClick={() =>
                        this.props.handleDownloadClick(row.amazonKey(), row.filename())
                      }
                    >
                      {this.localization.get('shared.download')}
                    </div>
                  </CustomTableCellDownload>
                )}

                <CustomTableCellDownload>
                  {/* Dacca links */}
                </CustomTableCellDownload>

                <CustomTableSentDateAndRefresh scope="row">
                  {this.localization.getFormatedDateTime(row.sentOn(), this.props.currentLanguage)}
                </CustomTableSentDateAndRefresh>

                <CustomTableCellCheckBox>
                  {row.needsApproval() ? (
                    <BelfiusTooltip title={row.createdByName()}>
                      <div>
                        <CheckCircleOutlineIcon
                          aria-owns="simple-menu"
                          aria-haspopup="true"
                        >
                          check_circle_outline
                        </CheckCircleOutlineIcon>
                      </div>
                    </BelfiusTooltip>
                  ) : (
                    ''
                  )}
                </CustomTableCellCheckBox>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
